import script from "./traffic.vue?vue&type=script&setup=true&lang=js"
export * from "./traffic.vue?vue&type=script&setup=true&lang=js"

import "./traffic.vue?vue&type=style&index=0&id=ada1e5a0&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada1e5a0"]])

export default __exports__